import { CopyIcon } from "components/common/Icons/CopyIcon";
import { TickIcon } from "components/common/Icons/TickIcon";
import { Source } from "store/features/colorPicker/types";
import { useColorCard } from "./useColorCard";

export interface ColorCardProps {
    hex: string;
    source: Source;
}

export const ColorCard = ({ hex, source }: ColorCardProps) => {
    const { isCopied, handleClick, hexRef } = useColorCard({ hex, source });
    return (
        <div className="group cursor-pointer flex flex-col gap-2" onClick={handleClick}>
            <div
                className="w-full aspect-square rounded-xl transition-all duration-250 flex items-center justify-center"
                style={{ backgroundColor: hex }}
            >
                {isCopied ? <TickIcon width={30} height={30} /> : <CopyIcon width={30} height={30} />}
            </div>
            <div className="text-center text-xl" ref={hexRef}>
                {hex}
            </div>
        </div>
    );
};
